import {
  domainToKey,
  keyToDomain,
  LOCATION_TYPES,
  ACTION_RECOMMENDATION_TYPE,
  RECOMMENDATION_SSO_LABEL_BY_VALUE,
} from './constants';
import { ObjectAny } from '@/utils/utils';

export const extractEmail = (email: string) => {
  const emailArr = email.split('@');
  const userId = emailArr[0];
  const domain = emailArr[1] || '';
  let key = domainToKey[domain] || '';
  return userId + (key && `#${key}`);
};

export const constructEmail = (id: string) => {
  const strArr = id.split('#');
  const userId = strArr[0];
  const key = strArr[1] || '';
  let domain = keyToDomain[key];
  return userId + (domain && `@${domain}`);
};

export const extractId = (email: string) => {
  const emailArr = email.split('@');
  const userId = emailArr[0];
  return userId;
};

export function generateSSOActionData(
  countries: string[],
  irecom: ObjectAny,
  osType: string,
  actionType: string,
  action: ObjectAny,
  isShowQueryParamProperties: boolean,
) {
  const actionDataKey = `actionData${osType}`;
  const ssoType = irecom[`ssoType${osType}`];
  const actionData = irecom[actionDataKey];
  const actionTypeByOs = generateSSOActionTypeByOs(actionType, ssoType);
  countries.forEach(country => {
    const {
      redirectUri,
      clientId,
      scope,
      state,
      queryParamProperties,
    } = actionData[country];
    const scopeParam = scope ? encodeURI(scope.join(' ')) : undefined;
    const queryParamPropertiesParam = queryParamProperties
      ? queryParamProperties
      : undefined;

    action.actionTypeByOs = actionTypeByOs;
    action.actionByOs[country] = JSON.stringify({
      redirectUri,
      clientId,
      ...(scopeParam ? { scope: scopeParam } : {}),
      state,
      ...(isShowQueryParamProperties
        ? queryParamPropertiesParam
          ? { queryParamProperties: queryParamPropertiesParam }
          : {}
        : {}),
    });
  });
}

function generateSSOActionTypeByOs(actionType: string, ssoType: string) {
  let actionTypeByOs = '';
  switch (actionType) {
    case ACTION_RECOMMENDATION_TYPE.WEB_LINK_SSO:
      actionTypeByOs =
        ACTION_RECOMMENDATION_TYPE.WEB_LINK +
        RECOMMENDATION_SSO_LABEL_BY_VALUE[ssoType];
      break;
  }
  return actionTypeByOs;
}

export function transformPrescriberSSOActionData(
  finalAction: ObjectAny,
  countries: string[],
  os: string,
  action: ObjectAny,
  actionKeyType: string,
) {
  const osData = finalAction[os] ? finalAction[os] : {};

  countries.forEach(country => {
    const actionData = action[country];
    let parsed: ObjectAny;

    try {
      parsed = JSON.parse(actionData);
    } catch (error) {
      console.error(error);
      console.log({ error });
      parsed = { redirectUri: '', scope: [], clientId: '' };
    }

    const {
      redirectUri = '',
      scope: rawScope = [],
      clientId = '',
      state = '',
      queryParamProperties: rawQueryParamProperties = [],
    } = parsed;
    const scope =
      rawScope && rawScope.length > 0 ? decodeURI(rawScope).split(' ') : [];
    const queryParamProperties =
      rawQueryParamProperties && rawQueryParamProperties.length > 0
        ? rawQueryParamProperties
        : [];
    const countryKey =
      actionKeyType === LOCATION_TYPES.COUNTRY
        ? country.toUpperCase()
        : country.toLowerCase();

    osData[countryKey] = {
      redirectUri,
      scope,
      clientId,
      state,
      queryParamProperties,
    };
    finalAction[os] = osData;
  });
}
